






































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class InputSearch extends Vue {
    @Prop({ type: String, required: false, default: '' })
    private value!: string;

    @Prop({ type: String, required: false, default: '' })
    private placeholder!: string;

    @Prop({ type: Boolean, required: false, default: false })
    private noBorder!: boolean;

    @Prop({ type: Boolean, required: false, default: false })
    private gray!: boolean;

    @Prop({ type: Boolean, required: false, default: false })
    private autofocus!: boolean;

    @Prop({ type: Boolean, required: false, default: true })
    private submitOnChange!: boolean;

    $refs!: {
        search?: HTMLInputElement
    }

    private get id() {
        return 'search-' + Math.random();
    }

    private reset() {
        this.$emit('input', '');
    }

    private get hasValue(): boolean {
        return this.value !== '' && this.value != null;
    }

    private get listeners() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { input, ...listeners } = this.$listeners;
        return listeners;
    }

    private changedInput(event) {
        if (this.submitOnChange) {
            this.$emit('input', event.target.value);
        }
    }

    handlePaste() {
        setTimeout(() => this.handleClickSubmit(), 200);
    }

    handleEnterKey(event) {
        if (!this.submitOnChange) {
            this.$emit('input', event.target.value);
        }
    }

    handleClickSubmit() {
        if (!this.submitOnChange) {
            this.$emit('input', this.$refs.search?.value || this.value);
        }
    }
}
